var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosFigmaColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75071 23C9.8203 23 11.5 21.2827 11.5 19.1667V15.3333H7.75071C5.68113 15.3333 4.00146 17.0507 4.00146 19.1667C4.00146 21.2827 5.68113 23 7.75071 23Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00146 11.5C4.00146 9.38399 5.68113 7.66666 7.75071 7.66666H11.5V15.3333H7.75071C5.68113 15.3333 4.00146 13.616 4.00146 11.5Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00146 3.83333C4.00146 1.71733 5.68113 0 7.75071 0H11.5V7.66667H7.75071C5.68113 7.66667 4.00146 5.94933 4.00146 3.83333Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0H15.2492C17.3188 0 18.9985 1.71733 18.9985 3.83333C18.9985 5.94933 17.3188 7.66667 15.2492 7.66667H11.5V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9985 11.5C18.9985 13.616 17.3188 15.3333 15.2492 15.3333C13.1797 15.3333 11.5 13.616 11.5 11.5C11.5 9.38399 13.1797 7.66666 15.2492 7.66666C17.3188 7.66666 18.9985 9.38399 18.9985 11.5Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFigmaColored);
export default __webpack_public_path__ + "static/media/logos-figma-colored.3a7b5e378125db8de4b9cc1615994ee7.svg";
export { ForwardRef as ReactComponent };